export default "__VITE_ASSET__CeDxgNwT__"